export const ElaneForecastData = {
  status: 0,
  data: {
    mmsi: 4131101,
    imo: 530527410,
    shipname: '4Q0',
    callsign: '5JJN9E',
    portname: 'Lanshan',
    portcode: 'CNLSN',
    portid: 25170,
    portname_ais: '1\\B><=9GYX',
    portid_ais: 0,
    calmode: 1,
    sailing_time: 29.55,
    eta: '2024-06-18 21:33:14',
    speed: 12.0,
    ais_time: '2024-06-17 15:54:50',
    distance: 354.55,
    route: [
      { lon: 121.13555, lat: 38.727367 },
      { lon: 122.74172, lat: 37.48967 },
      { lon: 122.71522, lat: 36.908215 },
      { lon: 122.5363, lat: 36.73833 },
      { lon: 120.66588, lat: 35.989433 },
      { lon: 120.43828, lat: 36.00847 },
      { lon: 120.21391, lat: 35.845047 },
      { lon: 120.1504, lat: 35.872833 },
      { lon: 119.8824, lat: 35.17335 },
      { lon: 119.6904, lat: 35.084583 },
      { lon: 119.40255, lat: 35.1601 },
    ],
    PortID: 621474,
    EnName: 'Lanshan',
    CnName: '岚山',
    CountryCode: 'CN',
    lon: 119.366667,
    lat: 35.099998,
    porttimezone: '+8',
  },
}
